const testimonials = [
  {
    name: "Dr. Elena V.",
    location: "Caltech, Pasadena",
    rating: 5,
    text: "I received a last-minute invitation to present at a conference in Zurich — departure was 11 days out and my passport had expired. Fast Passport Center walked me through the entire process, reviewed all my documents, and delivered my new passport in 7 business days. I made it to Zurich. For any researcher, this service is absolutely essential to have on speed dial.",
    service: "Emergency Renewal",
  },
  {
    name: "David & Linda C.",
    location: "Arcadia, CA",
    rating: 5,
    text: "We were visiting family in Taiwan for Lunar New Year and realized three weeks before departure that our daughter had never gotten a U.S. passport. Being first-time applicants, we were completely confused about the process. Fast Passport Center guided us step by step, told us exactly where to go in Pasadena, and had her passport ready with a week to spare. Absolutely saved our holiday trip.",
    service: "New Passport — Minor",
  },
  {
    name: "Robert T.",
    location: "San Marino, CA",
    rating: 5,
    text: "I am a retired engineer from JPL and my wife and I booked a Mediterranean cruise on short notice. My passport was still valid but hers had expired — we discovered this two weeks before sailing. Fast Passport Center had her renewal back to us in 6 business days. The price was significantly better than what I had seen quoted elsewhere, and the service was flawless. We sailed on time.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PasadenaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What San Gabriel Valley Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Pasadena, Arcadia, and San Marino travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}